import { IAccountFeature } from "../models/IAccountFeature.model";

let currentAccountDetails: IAccountFeature = {
  features: [
    {
      id: 1,
      text: "Issuance of Verve Card and Mastercard.",
    },
    {
      id: 2,
      text: "Online Statements.",
    },
    {
      id: 3,
      text: "Email/SMS alert.",
    },
    {
      id: 4,
      text: "Internet & Mobile banking facility.",
    },
    {
      id: 5,
      text: "International Funds Transfer allowed.",
    },
  ],
  requirements: [
    {
      id: 1,
      text: "Basic customer information (i.e., Name, Date of Birth, Gender, Address, Telephone Number) **Address would be verified.",
    },
    {
      id: 2,
      text: "BVN",
    },
    {
      id: 3,
      text: "Passport Photograph",
    },
    {
      id: 4,
      text: "Signature",
    },
    {
      id: 5,
      text: "Valid ID",
    },
    {
      id: 6,
      text: "2 Suitable references",
    },
  ],
};

let jointCurrentAccountDetails: IAccountFeature = {
  features: [
    {
      id: 1,
      text: "Minimum account opening balance of =N=5,000(Not Restrictive)",
    },
    {
      id: 2,
      text: "Access to consumer finance",
    },
    {
      id: 3,
      text: "Internet and mobile banking facility i.e., online statements, SMS alert etc.",
    },
    {
      id: 4,
      text: "Chequebook.",
    },
    {
      id: 5,
      text: "International Funds Transfer allowed.",
    },
    {
      id: 6,
      text: "Issuance of Verve Card and Mastercard.",
    },
  ],
  requirements: [
    {
      id: 1,
      text: "Basic customer information (i.e., Name, Date of Birth, Gender, Address, Telephone Number) **Address would be verified.",
    },
    {
      id: 2,
      text: "BVN",
    },
    {
      id: 3,
      text: "Passport Photograph",
    },
    {
      id: 4,
      text: "Signature",
    },
    {
      id: 5,
      text: "Valid ID",
    },
    {
      id: 6,
      text: "2 Suitable references",
    },
  ],
};

let domicillaryCurrentAccountDetails: IAccountFeature = {
  features: [
    {
      id: 1,
      text: "Minimum account opening balance of: is -USD 100 - GBP 100 - EUR0 100.",
    },
    {
      id: 2,
      text: "Attractive interest rate on tenured deposit.",
    },
    {
      id: 3,
      text: "Interest bearing.",
    },
    {
      id: 4,
      text: "Foreign cheque lodgement allowed (21 working days).",
    },
    {
      id: 5,
      text: "Allows for offshore remittances.",
    },
    {
      id: 6,
      text: "Internet Banking Facility & SMS Alert.",
    },
  ],
  requirements: [
    {
      id: 1,
      text: "Basic customer information (i.e., Name, Date of Birth, Gender, Address, Telephone Number) **Address would be verified.",
    },
    {
      id: 2,
      text: "BVN",
    },
    {
      id: 3,
      text: "Passport Photograph",
    },
    {
      id: 4,
      text: "Signature",
    },
    {
      id: 5,
      text: "Valid ID",
    },
    {
      id: 6,
      text: "2 Suitable references",
    },
  ],
};

/////////////////////

let swiftSavingsAccountDetails: IAccountFeature = {
  features: [
    {
      id: 1,
      text: "Maximum single deposit of N50,000.",
    },
    {
      id: 2,
      text: "Maximum cumulative balance/threshold of N300,000.",
    },
    {
      id: 3,
      text: "Instant account opening.",
    },
    {
      id: 4,
      text: "Email/SMS alert.",
    },
    {
      id: 5,
      text: "Online statements.",
    },
    {
      id: 6,
      text: "One account signatory.",
    },
    {
      id: 7,
      text: "Verve card only.",
    },
    {
      id: 8,
      text: "No International Funds Transfer.",
    },
  ],
  requirements: [
    {
      id: 1,
      text: "Basic customer information (i.e., Name, Place and date of Birth, Gender, Address, Telephone Number).",
    },
    {
      id: 2,
      text: "BVN or NIN",
    },
    {
      id: 3,
      text: "Passport Photograph",
    },
    {
      id: 4,
      text: "Signature",
    },
  ],
};

export const naira: string = "₦";

let savingsAccountDetails: IAccountFeature = {
  features: [
    {
      id: 1,
      text: "Maximum single deposit and cumulative balance threshold unlimited.",
    },
    {
      id: 2,
      text: "Issuance of Verve Card and Mastercard.",
    },
    {
      id: 3,
      text: "Online statements.",
    },
    {
      id: 4,
      text: "Email/SMS alert.",
    },
    {
      id: 5,
      text: "Internet & Mobile banking facility.",
    },
    {
      id: 6,
      text: "International Funds Transfer allowed.",
    },
    {
      id: 7,
      text: "Profit sharing.",
    },
  ],
  requirements: [
    {
      id: 1,
      text: "Basic customer information (i.e., Name, Date of Birth, Gender, Address, Telephone Number). Address would be verified.",
    },
    {
      id: 2,
      text: "BVN.",
    },
    {
      id: 3,
      text: "Passport Photograph.",
    },
    {
      id: 4,
      text: "Signature.",
    },
    {
      id: 5,
      text: "Valid ID.",
    },
  ],
};

let minorSavingsAccountDetails: IAccountFeature = {
  features: [
    {
      id: 1,
      text: "Maximum single deposit of N50,000.",
    },
    {
      id: 2,
      text: "Maximum cumulative balance/threshold of N300,000.",
    },
    {
      id: 3,
      text: "Instant account opening.",
    },
    {
      id: 4,
      text: "Email/SMS alert.",
    },
    {
      id: 5,
      text: "Online statements",
    },
    {
      id: 6,
      text: "One account signatory.",
    },
    {
      id: 7,
      text: "Verve card only.",
    },
    {
      id: 8,
      text: "No International Funds Transfer.",
    },
  ],
  requirements: [
    {
      id: 1,
      text: "Basic customer information (i.e., Name, Date of Birth, Gender, Address, Telephone Number) **Address would be verified.",
    },
    {
      id: 2,
      text: "Birth certificate of the minor/International passport / NIN Slip.",
    },
    {
      id: 3,
      text: "Parent's/Guardian's valid and acceptable means of Identification.",
    },
    {
      id: 4,
      text: "Passport photograph of minor and parent/guardian.",
    },
    {
      id: 5,
      text: "BVN of Parent/Guardian.",
    },
    {
      id: 6,
      text: "Signature of Parent/Guardian.",
    },
  ],
};

let jointSavingsAccountDetails: IAccountFeature = {
  features: [
    {
      id: 1,
      text: "Maximum single deposit and cumulative balance/threshold is unlimited.",
    },
    {
      id: 2,
      text: "Issuance of Verve Card and Mastercard.",
    },
    {
      id: 3,
      text: "Online Statements.",
    },
    {
      id: 4,
      text: "Email/SMS alert.",
    },
    {
      id: 5,
      text: "Internet & Mobile banking facility.",
    },
    {
      id: 6,
      text: "International Funds Transfer allowed.",
    },
  ],
  requirements: [
    {
      id: 1,
      text: "Basic customer information (i.e., Name, Date of Birth, Gender, Address, Telephone Number) **Address would be verified.",
    },
    {
      id: 2,
      text: "BVN",
    },
    {
      id: 3,
      text: "Passport Photograph",
    },
    {
      id: 4,
      text: "Signature",
    },
    {
      id: 5,
      text: "Valid ID",
    },
  ],
};

let domiciliarySavingsAccountDetails: IAccountFeature = {
  features: [
    {
      id: 1,
      text: "Minimum account opening balance of: is -USD 100 - GBP 100 - EUR0 100.",
    },
    {
      id: 2,
      text: "Foreign cheque lodgement allowed (21 working days).",
    },
    {
      id: 3,
      text: "Internet Banking Facility & SMS Alert.",
    },
    {
      id: 4,
      text: "International Funds Transfer allowed.",
    },
  ],
  requirements: [
    {
      id: 1,
      text: "Basic customer information (i.e., Name, Date of Birth, Gender, Address, Telephone Number) **Address would be verified.",
    },
    {
      id: 2,
      text: "BVN",
    },
    {
      id: 3,
      text: "Passport Photograph",
    },
    {
      id: 4,
      text: "Signature",
    },
    {
      id: 5,
      text: "Valid ID",
    },
    // {
    //   id: 6,
    //   text: "2 Suitable references.",
    // },
  ],
};

export const features = {
  currentAccountDetails,
  jointCurrentAccountDetails,
  domicillaryCurrentAccountDetails,
  swiftSavingsAccountDetails,
  savingsAccountDetails,
  minorSavingsAccountDetails,
  jointSavingsAccountDetails,
  domiciliarySavingsAccountDetails,
};
